/**
 * Author: postcodex
 */
__webpack_public_path__ = `${ postcodexLookupObj.publicPath }/`;
import React from 'react';
import ReactDOM from 'react-dom';
import $ from 'jquery';
import { debounce, uniqueId } from 'lodash';
import createSagaMiddleware from 'redux-saga';
import { applyMiddleware, createStore, compose } from 'redux';
import { Provider } from 'react-redux';
import reducers from './reducers';
import rootSaga from './sagas';
import App from './containers/App';

const postCodeInput = document.querySelectorAll( plAutosuggestAddrObj.postcodeSelector ),
      countryInput  = document.querySelector( plAutosuggestAddrObj.countrySelector );

const initApp = ( form ) => {
	const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
	const sagaMiddleware = createSagaMiddleware();
	const store = createStore( reducers, composeEnhancers( applyMiddleware( sagaMiddleware ) ) );
	sagaMiddleware.run( rootSaga );

	const postcodeInput = form.querySelector( plAutosuggestAddrObj.postcodeSelector );
	const formDataPlApp = form.getAttribute( 'data-pl-app' );
	const cacheId = formDataPlApp ?? uniqueId( 'plApp' );
	if ( !formDataPlApp ) {
		form.setAttribute( 'data-pl-app', cacheId );
	}

	const root = document.createElement( 'div' );
	root.id = cacheId;
	root.classList.add( 'pl-autosuggest-address', 'pl-custom' );
	document.body.appendChild( root );

	const cumulativeOffset = ( mainElement ) => {
		let top = 0,
		    left = 0,
		    element = mainElement;

		do {
			top += element.offsetTop || 0;
			left += element.offsetLeft || 0;
			element = element.offsetParent;
		} while ( element );

		return {
			top  : top + mainElement.offsetHeight,
			left : left
		};
	};
	const offset = cumulativeOffset( postcodeInput );

	let adminBarHeight = document.getElementById( 'wpadminbar' )?.offsetHeight ?? 0;
	root.style.top = offset.top + adminBarHeight + 'px';
	root.style.left = offset.left + 'px';
	root.style.width = 200 < postcodeInput.clientWidth ? postcodeInput.clientWidth + 'px' : '200px';

	ReactDOM.render(
		<Provider store={ store }>
			<App
				unmountAppEntry={ unmountAppEntry }
				cacheId={ cacheId }
				form={ form }
			/>
		</Provider>,
		root
	);
};

const unmountAppEntry = () => {
	const appRoot = document.querySelector( '.pl-autosuggest-address' );
	if ( !appRoot ) {
		return;
	}
	ReactDOM.unmountComponentAtNode( document.querySelector( '.pl-autosuggest-address' ) );
	document.querySelector( '.pl-autosuggest-address' ).remove();
};

const toggleFieldsDisplay = ( show = true ) => {
	const inputFields = [
		plAutosuggestAddrObj.address1Selector,
		plAutosuggestAddrObj.address2Selector,
		plAutosuggestAddrObj.citySelector,
	];

	if ( !show ) {
		inputFields.forEach( fieldId => {
			const field     = document.querySelector( fieldId ),
			      container = field?.closest( `${ fieldId }_field` );
			if ( container ) {
				container.style.display = 'none';
			}
		} );
	} else {
		inputFields.forEach( fieldId => {
			const field     = document.querySelector( fieldId ),
			      container = field?.closest( `${ fieldId }_field` );
			if ( container ) {
				container.style.display = 'block';
			}
		} );
	}
};

const togglePostCodeDesc = ( show = true ) => {
	let postcodeDesc = document.querySelectorAll( '.pl-postcode-desc' );
	if ( !postcodeDesc.length && show ) {
		postcodeDesc = document.createElement( 'span' );
		postcodeDesc.classList.add( 'pl-postcode-desc' );
		if ( 'yes' === plAutosuggestAddrObj.autosearch ) {
			postcodeDesc.innerText = 'Enter your postcode to automatically find your address.';
		} else {
			postcodeDesc.innerHTML = 'Enter your postcode and click <code>SEARCH</code> button to find your address.';
		}

		postCodeInput.forEach( node => {
			node.closest( `#${ node.id }_field` )?.appendChild( postcodeDesc );
		} );
	} else if ( postcodeDesc ) {
		postCodeInput.forEach( node => {
			console.log( node );
			node.closest( `#${ node.id }_field` )?.removeChild( postcodeDesc );
		} );
	}
};

const toggleSearchBtnDisplay = ( show = true ) => {
	const { autosearch, isCheckout } = plAutosuggestAddrObj;

	if ( ( !isCheckout || ( isCheckout && countryInput && 'GB' === countryInput.value ) ) && show && 'no' === autosearch ) {
		document.body.classList.add( 'pl-no-autosuggest' );
		postCodeInput.forEach( node => {
			const searchBtn = document.createElement( 'button' );
			searchBtn.classList.add( 'pl-search-addresses-btn', 'btn', 'btn-secondary' );
			searchBtn.type = 'button';
			searchBtn.textContent = 'Search';
			searchBtn.addEventListener( 'click', handleSearchBtnClick );
			node.parentNode.insertBefore( searchBtn, node.nextSibling );
		} );
	} else if ( 'no' === autosearch && ( !show || ( isCheckout && countryInput && 'GB' !== countryInput.value ) ) ) {
		const searchBtn = document.querySelectorAll( '.pl-search-addresses-btn' );
		if ( !!searchBtn.length ) {
			searchBtn.forEach( btn => {
				btn.remove();
				document.body.classList.remove( 'pl-no-autosuggest' );
			} );
		}
	}
};

const handleSearchBtnClick = ( e ) => {
	const form = e.target.closest( 'form' );
	initApp( form );
};

const debouncedToggleFieldsDisplay = debounce( () => { toggleFieldsDisplay( false );}, 10 );

const postCodeChange = ( e ) => {
	const form = e.target.closest( 'form' );
	if ( ( plAutosuggestAddrObj.isCheckout && countryInput && 'GB' === countryInput.value ) ||
		!form.querySelector( '.pl-autosuggest-address' ) && 2 <= e.target.value.trim().length ) {
		initApp( form );
	} else if ( form.querySelector( '.pl-autosuggest-address' ) && 2 > e.target.value.trim().length ) {
		unmountAppEntry( form );
	}
};

const debouncePostcodeChange = debounce( ( e ) => { postCodeChange( e );}, 700 );

if ( !!postCodeInput.length && 'yes' === plAutosuggestAddrObj.autosearch ) {
	postCodeInput.forEach( node => {
		node.addEventListener( 'keyup', debouncePostcodeChange );
		node.addEventListener( 'focus', postCodeChange );
	} );
}

document.addEventListener( 'mousedown', ( e ) => {
	const appNode = document.querySelectorAll( '.pl-autosuggest-address' );
	postCodeInput.forEach( input => {
		if ( input && !input?.contains( e.target ) && !!appNode.length ) {
			appNode.forEach( node => {
				if ( !node.contains( e.target ) ) {
					unmountAppEntry( node.closest( 'form' ) );
				}
			} );
		}
	} );
} );

$( plAutosuggestAddrObj.countrySelector ).on( 'change', ( e ) => {
	if ( 'GB' === e.target.value ) {
		togglePostCodeDesc();
		toggleSearchBtnDisplay();
	} else {
		unmountAppEntry( document.querySelector( plAutosuggestAddrObj.countrySelector ).closest( 'form' ) );
		togglePostCodeDesc( false );
		toggleSearchBtnDisplay( false );
	}
} );

$( function () {
	if ( !plAutosuggestAddrObj.isCheckout || ( plAutosuggestAddrObj.isCheckout && countryInput && 'GB' === countryInput.value ) ) {
		togglePostCodeDesc();
		toggleSearchBtnDisplay();
	}
} );
